export const palette = {
  common: {
    black: '#000',
    white: '#FFF',
  },
  primary: {
    main: '#282B3A',
    light: '#35394B',
    dark: '#1E1E1E',
  },
  secondary: {
    main: 'rgba(255, 255, 255, 0.7)',
    dark: '#4A4E5D',
    light: 'rgba(255, 255, 255, 0.19)',
    contrastText: '',
  },
  info: {
    main: '#00667C',
    light: '#57748C',
    dark: '#06404D',
    extralight: '#9CB0C1',
  },
  warning: {
    main: '#FFD900',
  },
  error: {
    main: '#FF8663',
  },
  success: {
    main: '#88B856',
  },
  text: {
    primary: '#fff',
    secondary: '#C3C4C8',
    disabled: '#c3c4c8',
  },
};
